/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.6.3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function RoomFromJSON(json) {
    return RoomFromJSONTyped(json, false);
}
export function RoomFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'roomId': !exists(json, 'roomId') ? undefined : json['roomId'],
        'floorId': !exists(json, 'floorId') ? undefined : json['floorId'],
        'buildingId': !exists(json, 'buildingId') ? undefined : json['buildingId'],
        'propertyId': !exists(json, 'propertyId') ? undefined : json['propertyId'],
        'buildingCode': !exists(json, 'buildingCode') ? undefined : json['buildingCode'],
        'floorCode': !exists(json, 'floorCode') ? undefined : json['floorCode'],
        'roomCode': !exists(json, 'roomCode') ? undefined : json['roomCode'],
        'roomName': !exists(json, 'roomName') ? undefined : json['roomName'],
        'roomDescription': !exists(json, 'roomDescription') ? undefined : json['roomDescription'],
        'use': !exists(json, 'use') ? undefined : json['use'],
        'category': !exists(json, 'category') ? undefined : json['category'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'vacancy': !exists(json, 'vacancy') ? undefined : json['vacancy'],
        'department': !exists(json, 'department') ? undefined : json['department'],
        'area': !exists(json, 'area') ? undefined : json['area'],
        'gps': !exists(json, 'gps') ? undefined : json['gps'],
        'roomBoundry': !exists(json, 'roomBoundry') ? undefined : json['roomBoundry'],
        'buildingSpecialCode': !exists(json, 'buildingSpecialCode') ? undefined : json['buildingSpecialCode'],
        'firstname': !exists(json, 'firstname') ? undefined : json['firstname'],
        'lastname': !exists(json, 'lastname') ? undefined : json['lastname'],
        'departmentID': !exists(json, 'departmentID') ? undefined : json['departmentID'],
        'cCompositeCode': !exists(json, 'cCompositeCode') ? undefined : json['cCompositeCode'],
        'cRoomCodeForSort': !exists(json, 'cRoomCodeForSort') ? undefined : json['cRoomCodeForSort'],
        'utiLCLat': !exists(json, 'utiL__cLat') ? undefined : json['utiL__cLat'],
        'utiLCLong': !exists(json, 'utiL__cLong') ? undefined : json['utiL__cLong'],
        'utiLLatNEW': !exists(json, 'utiL__LatNEW') ? undefined : json['utiL__LatNEW'],
        'utiLLongNEW': !exists(json, 'utiL__LongNEW') ? undefined : json['utiL__LongNEW'],
        'utiLCNewGPS': !exists(json, 'utiL__cNewGPS') ? undefined : json['utiL__cNewGPS'],
    };
}
export function RoomToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'roomId': value.roomId,
        'floorId': value.floorId,
        'buildingId': value.buildingId,
        'propertyId': value.propertyId,
        'buildingCode': value.buildingCode,
        'floorCode': value.floorCode,
        'roomCode': value.roomCode,
        'roomName': value.roomName,
        'roomDescription': value.roomDescription,
        'use': value.use,
        'category': value.category,
        'type': value.type,
        'vacancy': value.vacancy,
        'department': value.department,
        'area': value.area,
        'gps': value.gps,
        'roomBoundry': value.roomBoundry,
        'buildingSpecialCode': value.buildingSpecialCode,
        'firstname': value.firstname,
        'lastname': value.lastname,
        'departmentID': value.departmentID,
        'cCompositeCode': value.cCompositeCode,
        'cRoomCodeForSort': value.cRoomCodeForSort,
        'utiL__cLat': value.utiLCLat,
        'utiL__cLong': value.utiLCLong,
        'utiL__LatNEW': value.utiLLatNEW,
        'utiL__LongNEW': value.utiLLongNEW,
        'utiL__cNewGPS': value.utiLCNewGPS,
    };
}
